/**
 * Utilitários para gerenciar URLs com proxy em desenvolvimento
 */

import { logger } from './logger.util';

const PROXY_PORT = 24944;
const PROXY_HOST = '127.0.0.1';

/**
 * Verifica se está em modo desenvolvimento
 */
export function isDevelopment(): boolean {
  return import.meta.env.DEV || import.meta.env.MODE === 'development';
}

/**
 * Converte uma URL para usar o proxy local
 * 
 * @param url URL original (ex: https://api.vivofree.com.br/path)
 * @param force Forçar conversão mesmo se não estiver em desenvolvimento
 * @returns URL através do proxy (ex: http://localhost:24944/api.vivofree.com.br/path)
 */
export function convertToProxyUrl(url: string, force: boolean = false): string {
  if (!force && !isDevelopment()) {
    return url;
  }

  try {
    const urlObj = new URL(url);
    const host = urlObj.host;
    const path = urlObj.pathname + urlObj.search;
    
    // Formato: http://localhost:24944/host/path
    return `http://${PROXY_HOST}:${PROXY_PORT}/${host}${path}`;
  } catch (error) {
    logger.error('Error converting URL to proxy format:', error);
    return url;
  }
}

/**
 * Constrói URL da API usando proxy se necessário
 * 
 * @param baseUrl URL base da API
 * @param path Caminho do endpoint
 * @returns URL completa (com proxy em desenvolvimento)
 */
export function buildApiUrl(baseUrl: string, path: string): string {
  // Remover barra final da baseUrl se existir
  const cleanBaseUrl = baseUrl.replace(/\/$/, '');
  // Remover barra inicial do path se existir
  const cleanPath = path.replace(/^\//, '');
  
  const fullUrl = `${cleanBaseUrl}/${cleanPath}`;
  
  return convertToProxyUrl(fullUrl);
}

